import styled from 'styled-components';
import { TotalVariant } from './types';

export const TotalCard = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing[4]};
  box-shadow: ${({ theme }) => theme.shadows.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TotalContent = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  flex: 1;
`;

export const TotalLabel = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;
`;

export const TotalValueContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing[1]};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const TotalValue = styled.p<{ $variant: TotalVariant }>`
  font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

export const TotalSymbol = styled.span<{ $variant: TotalVariant }>`
  font-size: ${({ theme, $variant }) => 
    $variant === 'amount' 
      ? theme.typography.fontSize.lg 
      : theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const TotalIcon = styled.div<{ $color?: string; $iconColor?: string }>`
  padding: ${({ theme }) => theme.spacing[3]};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  background-color: ${({ $color, theme }) => $color || theme.colors.primary};
  color: ${({ $iconColor }) => $iconColor || 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: currentColor;
    width: 1.5rem;
    height: 1.5rem;
  }
`;
